import ApiClient from './ApiClient';

class MarketingEmailTemplatesAPI extends ApiClient {
  constructor() {
    super('marketing_email_templates', { accountScoped: true });
  }
}

export default new MarketingEmailTemplatesAPI();
